<!--
 * @Author: your name
 * @Date: 2021-04-13 13:20:56
 * @LastEditTime: 2021-06-30 16:33:22
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \ecfc-henan-oms-facade-SIT\src\views\home\components\sidebar\Item.vue
-->
<script>
export default {
  name: 'MenuItem',
  functional: true,
  data () {
    return {
      isCollapse: this.isCollapse
    }
  },
  props: {
    icon: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: ''
    },
    isCollapse: {
      type: Boolean,
      default: false
    },
  },
  render(h, context) {
    const { icon, title, isCollapse } = context.props
    const vnodes = []

    if (icon) {
      if (isCollapse) {
        vnodes.push(<div class="ec-menu__titlewrap"><ec-svg-icon icon-class={icon}/><div class="ec-menu__title" slot='title'>{(title)}</div></div>)
      } else {
        vnodes.push(<ec-svg-icon icon-class={icon}/>)
      }
    }
    if (title) {
      vnodes.push(<span slot='title'>{(title)}</span>)
    }
    return vnodes
  }
}
</script>
<style lang="scss" scoped>
@import '~@/styles/theme/variables.scss';
.ec-menu {
  &__titlewrap .svg-icon {
    font-size: 26px !important;
  }
  &__title {
    font-size: 14px;
    color: $primaryTxtColor;//#FFFFFF;
    text-align: center;
  }
  &__title:hover,
  &__title:focus{
    color:#fff !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/home/components/EcMenu/Item.vue